import controller from './notifications.controller';

const template = require('./notifications.html');

export default {
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/notifications/notifications.component.js